var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$msal.isAuthenticated())?_c('BaseHeader'):_vm._e(),_c('router-view'),(_vm.$msal.isAuthenticated())?_c('BaseFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }